import Vue from 'vue';

export const state = () => ({
  state: () => ({
    loading: false,
    data: null,
    current_step: null,
  }),
});

export const getters = {
  get(state) {
    return state.data;
  },

  id(state) {
    if (!state.data) {
      return false;
    }

    return state.data._id;
  },
};

export const mutations = {
  set(state, pip) {
    state.loading = false;
    Vue.set(state, 'data', pip);
  },

  setStatus(state, status) {
    state.data.status = status;
  },

  setWizard(state, wizard) {
    state.data.loading = false;
    state.data.wizard = wizard;
  },

  setNotes(state, notes) {
    state.data.loading = false;
    state.data.notes = notes;
  },

  loading(state) {
    state.loading = true;
  },

  setCurrentStep(state, route) {
    Vue.set(state, 'current_step', route);
  },
};

export const actions = {
  get({ commit }, writtenId) {
    commit('loading');

    return this.$axios
      .get(`/v0/app/written-warning/${writtenId}`)
      .then((res) => {
        commit('set', res.data);

        return res.data;
      });
  },

  updateWizard({ commit, getters }, wizard) {
    commit('loading');

    return this.$axios
      .post(`/v0/app/written-warning/${getters.id}/update`, { wizard })
      .then((res) => {
        commit('setWizard', res.data.wizard);
        commit('setStatus', res.data.status);

        return res.data.wizard;
      });
  },

  completeWritten({ commit, getters }) {
    commit('loading');

    return this.$axios
      .post(`/v0/app/written-warning/${getters.id}/complete`)
      .then((res) => {
        commit('set', res.data);

        return res.data;
      });
  },

  addSectionNote({ commit, getters }, note) {
    commit('loading');

    return this.$axios
      .post(`/v0/app/written-warning/${getters.id}/add-note`, { note })
      .then((res) => {
        commit('setNotes', res.data.notes);

        return res.data.notes;
      });
  },

  deleteSectionNote({ commit, getters }, noteId) {
    return this.$axios
      .post(`/v0/app/written-warning/${getters.id}/delete-note/${noteId}`)
      .then((res) => {
        commit('setNotes', res.data.notes);

        return res.data.notes;
      });
  },

  async markMeetingComplete({ dispatch }, id) {
    const { data } = await this.$axios.post(
      `/v0/app/written-warning/${id}/meeting-complete`
    );

    dispatch('caps/updateCAP', { data }, { root: true });
  },
};
